// extracted by mini-css-extract-plugin
export default {"content":"Message_content__JH3LU"};